import { Component, Vue } from 'vue-property-decorator';
import { groupBy, indexItemsById } from '@/helpers/IndexHelpers';
import MyMembership from '@/components/membership/PurchasedMembership.vue';
import { API } from '@/api/API';
import { getMembershipRules } from '@/api/Membership';
import { isCurrentOrPastMember, mostRecentMemberships } from '@/state/Membership';
import store from '@/store/store';
// TODO Clean up names of MyMembership and PurchasedMembership types and components.
@Component({
    components: { MyMembership },
})
export default class MembershipDetailsRoute extends Vue {
    loading = false;
    ticketTypes;
    savedPaymentMethodsResponse = null;
    membershipRules = null;
    async created() {
        if (this.hasMembership) {
            this.loading = true;
            this.initSavedPaymentMethods().finally(() => {
                this.loading = false;
            });
            this.membershipRules = await this.fetchMembershipRules();
        }
    }
    get memberships() {
        return mostRecentMemberships();
    }
    get tickets() {
        return groupBy('ticket_order_id', store.getters['Member/allTickets']);
    }
    async fetchMembershipRules() {
        // Only fetch rules for ticket types that are actually used for current member.
        const typesById = indexItemsById(store.getters['Member/ticketTypes']);
        return getMembershipRules({ 'ticket_type.id._in': Object.keys(typesById) });
    }
    async initSavedPaymentMethods() {
        this.savedPaymentMethodsResponse = await API.getUncached('my/identity/saved_payment_method');
    }
    // TODO Is there really only one membership scan code per user, even if they have multiple memberships?
    get membershipScanCode() {
        return store.getters['Member/membershipScanCode'];
    }
    get savedCard() {
        return this.savedPaymentMethodsResponse.saved_payment_method._data[0];
    }
    get hasMembership() {
        return isCurrentOrPastMember();
    }
}
